import { Translation } from '../types';

export default {
  // App
  appTitle: "OK Money - ライフプランシミュレーター",

  // Navigation
  navigation: {
    home: "ホーム",
    lifePlan: "ライフプラン",
    riskSimulation: "リスクシミュレーション",
    contact: "お問い合わせ",
    openMenu: "メニューを開く",
    lifePlanDescription: "ライフプランを作成して、将来の生活を設計します",
    riskSimulationDescription: "リスクシミュレーションを実行して、投資のリスクを評価します",
  },

  // Home
  home: {
    hero: {
      title: "シミュレーションによるリアルな人生設計",
      subtitle: "不確実性を考慮したシミュレーションで、あなたのライフプランを最適化",
      download: "ダウンロード",
      docs: "ドキュメント"
    },
    features: {
      codeCompletion: {
        title: "リアルタイムシミュレーション",
        description: "市場の変動をリアルタイムでシミュレーションし、最適なマネープランを提案します"
      },
      codebase: {
        title: "AI分析",
        description: "過去のデータとAIを活用して、あなたの投資ポートフォリオを分析し、改善点を提案します"
      },
      naturalLanguage: {
        title: "人生を豊かにする投資を",
        description: "投資で資産を増やしつつ、生活に必要な資金は確実に確保できる安心感を"
      }
    },
  },

  // 会社情報と利用規約
  company: {
    title: "会社情報",
    basicInfo: "基本情報",
    operatorName: "運営会社名",
    startDate: "設立日",
    startDateValue: "2025年4月28日",
    location: "所在地",
    locationValue: "神奈川県横浜市",
    contact: "お問い合わせ",
    contactForm: "お問い合わせフォーム",
    businessDescription: "事業内容",
    businessDescriptionContent: "ライフプランシミュレーションサービスの提供",
    developerProfile: "開発者プロフィール",
    developerProfileContent: "SIerのエンジニアが個人開発しています。子供が誕生し人生設計を行う上で将来、そして現在を思う存分楽しめることに寄与できるサービスを目指しています。目指しています。",
    privacyPolicy: "プライバシーポリシー",
    privacyPolicyLink: "プライバシーポリシー全文はこちら",
    termsOfService: "利用規約",
    termsOfServiceContent: "当社は、お客様の個人情報の保護を最重要事項と考えています。",
    contentEnd: "ご不明な点がございましたら、お問い合わせください。"
  },
  terms: {
    title: "利用規約",
    termsOfService: "利用規約",
    privacyPolicy: "プライバシーポリシー",
    article1: {
      title: "第1条（適用）",
      content: "本規約は、OKMoney（以下「当社」といいます）が提供するサービス（以下「本サービス」といいます）の利用条件を定めるものです。"
    },
    article2: {
      title: "第2条（利用登録）",
      content1: "1. 本サービスを利用するには、本規約に同意の上、当社が定める方法により利用登録を行う必要があります。",
      content2: "2. 当社は、利用登録の申請者について、以下の事由があると判断した場合、利用登録を拒否することがあります。",
      listItem1: "本規約に違反したことがある者からの申請である場合",
      listItem2: "その他、当社が利用登録を相当でないと判断した場合"
    },
    article3: {
      title: "第3条（禁止事項）",
      content: "ユーザーは、以下の行為をしてはなりません：",
      listItem1: "法令または公序良俗に違反する行為",
      listItem2: "犯罪行為に関連する行為",
      listItem3: "当社のサービスの運営を妨害するおそれのある行為",
      listItem4: "他のユーザーに迷惑をかける行為",
      listItem5: "その他、当社が不適切と判断する行為"
    },
    article4: {
      title: "第4条（本サービスの提供の停止等）",
      content: "当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします：",
      listItem1: "本サービスにかかるコンピュータシステムの保守点検または更新を行う場合",
      listItem2: "地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合",
      listItem3: "その他、当社が本サービスの提供が困難と判断した場合"
    },
    article5: {
      title: "第5条（免責事項）",
      content: "当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。"
    },
    article6: {
      title: "第6条（サービス内容の変更等）",
      content: "当社は、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。"
    },
    article7: {
      title: "第7条（利用規約の変更）",
      content: "当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。"
    },
    article8: {
      title: "第8条（通知または連絡）",
      content: "ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。"
    },
    article9: {
      title: "第9条（権利義務の譲渡の禁止）",
      content: "ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。"
    },
    article10: {
      title: "第10条（準拠法・裁判管轄）",
      content1: "1. 本規約の解釈にあたっては、日本法を準拠法とします。",
      content2: "2. 本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。"
    },
    privacy: {
      article1: {
        title: "1. 個人情報の収集について",
        content: "当サイトでは、サービスの提供にあたり、以下の個人情報を収集する場合があります：",
        listItem1: "氏名",
        listItem2: "メールアドレス",
        listItem3: "住所",
        listItem4: "電話番号",
        listItem5: "その他、サービス提供に必要な情報"
      },
      article2: {
        title: "2. 個人情報の利用目的",
        content: "収集した個人情報は、以下の目的で利用されます：",
        listItem1: "サービスの提供・運営",
        listItem2: "お問い合わせへの対応",
        listItem3: "サービスの改善・開発",
        listItem4: "重要なお知らせの通知"
      },
      article3: {
        title: "3. 個人情報の管理",
        content: "当サイトでは、個人情報の漏洩、滅失、毀損を防止するため、適切なセキュリティ対策を実施しています。"
      },
      article4: {
        title: "4. 個人情報の第三者提供",
        content: "当サイトでは、以下の場合を除き、個人情報を第三者に提供することはありません：",
        listItem1: "ご本人の同意がある場合",
        listItem2: "法令に基づく場合",
        listItem3: "人の生命、身体または財産の保護のために必要がある場合"
      },
      article5: {
        title: "5. お問い合わせ",
        content: "プライバシーポリシーに関するお問い合わせは、お問い合わせフォームよりご連絡ください。"
      },
      article6: {
        title: "6. プライバシーポリシーの変更",
        content: "当サイトは、必要に応じて本プライバシーポリシーを変更することがあります。変更の際は、当サイトにてお知らせいたします。"
      }
    }
  },

  // 共通
  common: {
    age: "年齢",
    years: "年",
    perYear: "/年",
    perMonth: "/月",
    yes: "はい",
    no: "いいえ",
    none: "なし",
    notEntered: "未入力",
    add: "追加",
    delete: "削除",
    save: "保存",
    cancel: "キャンセル",
    reset: "リセット",
    month: "月",
    select: "選択",
    clearSelection: "選択をクリア",
    dateTime: "日時",
    actions: "操作",
    currency: "通貨",
    currencyHelp: "通貨を選択してください。シミュレーションは選択した通貨で行われます。",
    currencies: {
      jpy: "日本円",
      usd: "米ドル",
      eur: "ユーロ",
      gbp: "英ポンド",
      aud: "豪ドル",
      cad: "カナダドル",
      chf: "スイスフラン",
      cny: "人民元",
      hkd: "香港ドル",
      sgd: "シンガポールドル"
    },
    statistics: {
      title: "統計",
      mean: "平均",
      median: "中央値",
      min: "最小値",
      max: "最大値",
      mode: "最頻値",
      totalInvestment: "総投資額",
      assetDistribution: "資産配分",
      targetAchieveRate: "目標達成率",
      probability: "確率",
      medianFinalAsset: "中央値最終資産",
      finalAsset: "最終資産",
    }
  },

  // リスクシミュレーション
  riskSimulation: {
    title: "リスクシミュレーション",
    simulationSettings: "シミュレーション設定",
    initialInvestment: "初期投資額",
    investmentAmount: "投資額",
    investmentPeriod: "投資期間",
    annualReturnRate: "年間リターン率",
    monthlyInvestment: "月間投資額",
    volatility: "ボラティリティ",
    targetAmount: "目標金額",
    runSimulation: "シミュレーション実行",
    running: "実行中",
    simulationInstruction: "まずシミュレーションを実行してください。",
    noSimulationRun: "シミュレーション未実行",
    simulationResults: "シミュレーション結果",
    currentResults: "現在の結果",
    savedResults: "保存済み結果",
    compare: "比較",
    resultTitle: "リスクシミュレーション結果",
    simulationConditions: "シミュレーション条件",
    saveSimulationResult: "シミュレーション結果を保存",
    saveSimulationDescription: "シミュレーション結果の名前を入力してください。",
    simulationName: "シミュレーション名",
    simulationNamePlaceholder: "シミュレーション結果の名前を入力",
    saveSimulation: "シミュレーションを保存",
    noSavedSimulations: "保存済みシミュレーションなし",
    noSavedSimulationsDescription: "保存済みのシミュレーションが見つかりません。まずシミュレーションを実行してください。",
    createNewSimulation: "新規シミュレーション作成",
    selectSimulationsToCompare: "比較するシミュレーションを選択",
    noSelectedSimulations: "選択されたシミュレーションなし",
    selectTwoOrMoreSimulations: "2つ以上のシミュレーションを選択してください。",
    comparisonResults: "比較結果",
    finalAssetComparison: "最終資産比較",
    finalAssetComparisonDescription: "シミュレーションの最終資産の比較",
    successRateComparison: "成功率比較",
    successRateComparisonDescription: "シミュレーションの成功率の比較",
    simulationParameters: "シミュレーションパラメータ",
    simulationParametersDescription: "シミュレーションのパラメータ比較",
    period: "期間",
    successRate: "成功率",
    backToSimulation: "シミュレーションに戻る",
    timeSeriesChart: {
      title: "資産推移シミュレーション",
      description: "将来の資産残高がどのように推移するか、リスク（不確実性）を含めて可視化したグラフです。",
    },
    percentiles: {
      p95: "楽観的シナリオ (上位5%)",
      p50: "中央値シナリオ (50%)",
      p5: "悲観的シナリオ (下位5%)",
      p95_desc: "上位5%の確率で到達する資産額（市場環境が良い場合）",
      p50_desc: "シミュレーションの中央値（最も標準的な推移）",
      p5_desc: "下位5%の確率で発生する資産額（市場環境が悪い場合）",
    },
  },

  // ライフプラン
  lifePlan: {
    title: "ライフプラン作成",
    resultTitle: "ライフプランシミュレーション結果",
    steps: {
      basicInfo: "基本情報",
      incomeExpense: "収入・支出",
      assetsLiabilities: "資産・負債",
      lifeGoals: "ライフイベント",
      simulationSettings: "シミュレーション設定",
      confirmation: "確認",
    },
    navigation: {
      prev: "前へ",
      next: "次へ",
      startSimulation: "シミュレーション開始",
      confirmStart: "シミュレーションを開始しますか？",
      confirmStartTitle: "シミュレーション開始の確認",
      cancel: "キャンセル",
    },
    basicInfo: {
      title: "基本情報",
      name: "名前",
      namePlaceholder: "名前を入力",
      age: "年齢",
      gender: {
        title: "性別",
        male: "男性",
        female: "女性",
        other: "その他",
      },
      familyStructure: {
        title: "家族構成",
        hasSpouse: "配偶者有り",
        spouseAge: "配偶者の年齢",
        children: "子ども",
        help: "家族構成を入力",
        childrenHelp: "子どもの年齢を入力",
        addChild: "子どもを追加",
        removeChild: "子どもを削除",
        noChildren: "子どもなし",
      },
      spouse: "配偶者",
      children: "子ども"
    },
    incomeExpense: {
      title: "収入・支出",
      income: {
        title: "収入",
        annualIncome: "年収",
        salaryIncreaseRate: "昇給率（%）",
        annualBonus: "年間ボーナス",
      },
      expense: {
        title: "支出",
        help: "月間支出を入力してください",
        housingCost: "住居費",
        housingCostHelp: "月々の家賃やローン返済額を入力してください",
        utilities: "光熱費",
        food: "食費",
        communication: "通信費",
        transportation: "交通費",
        entertainment: "娯楽費",
        investment: "投資",
        stocks: "株式投資",
        bonds: "債券投資",
        mutualFunds: "投資信託",
        insurance: "保険料",
        other: "その他"
      },
      annualIncome: "年収",
      salaryIncreaseRate: "昇給率",
      annualBonus: "年間ボーナス",
      housingCost: "住居費",
      utilities: "光熱費",
      food: "食費",
      communication: "通信費",
      transportation: "交通費",
      entertainment: "娯楽費",
      other: "その他"
    },
    assetsLiabilities: {
      title: "資産・負債",
      assets: {
        title: "資産",
        savings: "預貯金",
        stocks: "株式",
        bonds: "債券",
        mutualFunds: "投資信託",
        insurance: "保険",
        other: "その他",
        amount: "金額",
        return: "期待リターン",
        volatility: "ボラティリティ",
        investmentAssets: "投資資産",
      },
      liabilities: {
        title: "負債",
        housingLoan: "住宅ローン",
        carLoan: "自動車ローン",
        otherLoans: "その他のローン",
        addLoan: "ローンを追加",
        removeLoan: "ローンを削除",
        name: "ローン名",
        amount: "ローン金額",
        period: "返済期間",
        interestRate: "金利",
        noLoans: "ローンなし",
      },
      savings: "預貯金",
      stocks: "株式",
      bonds: "債券",
      mutualFunds: "投資信託",
      insurance: "保険",
      otherInvestments: "その他の投資",
      housingLoanBalance: "住宅ローン残高",
      housingLoanPeriod: "住宅ローン返済期間",
      housingLoanInterest: "住宅ローン金利",
      otherLoans: "その他のローン",
      noLoans: "ローンなし",

    },
    lifeGoals: {
      title: "ライフイベント",
      housingPurchase: "住宅購入",
      educationFunds: "教育資金",
      child: "子ども",
      otherGoals: "その他の目標",
      retirementAge: "退職年齢",
      retirementMonthlyExpense: "退職後の月間支出",
      notPlanned: "未計画",
      housing: {
        title: "住宅購入",
        planned: "住宅購入予定",
        year: "購入予定年",
        amount: "購入予定金額",
        purchaseAmount: "購入金額",
        purchaseYear: "購入時期",
      },
      education: {
        title: "教育資金計画",
        subtitle: "教育資金の計画",
        add: "教育資金を追加",
        remove: "教育資金を削除",
        name: "教育資金名",
        namePlaceholder: "教育資金名を入力",
        childAge: "子供の年齢",
        age: "必要年齢",
        amount: "必要金額",
        requiredAmount: "必要金額",
        noData: "教育資金が追加されていません",
      },
      other: {
        title: "その他の目標",
        subtitle: "その他のライフイベント",
        namePlaceholder: "その他の目標名を入力してください",
        plannedAge: "予定年齢",
        requiredAmount: "必要金額",
        add: "目標を追加",
        remove: "目標を削除",
        name: "目標名",
        year: "目標年",
        amount: "必要金額",
        noData: "目標がありません",
      },
      retirement: {
        title: "退職計画",
        age: "予定退職年齢",
        monthlyExpense: "退職後の月間支出",
      },
    },
    simulationSettings: {
      title: "シミュレーション設定",
      inflationRate: "インフレ率",
      investmentReturn: "投資リターン",
      simulationPeriod: "シミュレーション期間",
      currency: "通貨",
      currencyHelp: "通貨を選択してください。シミュレーションは選択した通貨で行われます。",
      inflationRateHelp: "将来の物価上昇率を考慮したシミュレーションを行います。"
    },
    runningSimulation: "シミュレーション実行中",
    result: {
      title: "ライフプランシミュレーション結果",
      settings: "ライフプラン設定",
      planSettings: "プラン設定",
      actions: {
        print: "印刷",
        downloadCSV: "CSVダウンロード",
        modifyConditions: "条件を変更",
        backToInput: "入力画面に戻る",
      },
      tabs: {
        charts: "グラフ",
        details: "詳細",
        analysis: "分析・推奨",
      },
      charts: {
        assetIncomeExpense: "資産・収支推移",
        agePoint: "{age}歳時点",
        spouse: "配偶者: {age}歳",
        children: "子ども",
        age: "{age}歳",
        assets: "資産",
        liabilities: "負債",
        netWorth: "純資産",
        amount: "金額",
        noData: "データがありません",
        assetTrend: "資産推移",
        incomeExpenseTrend: "収支推移",
        income: "収入",
        expense: "支出",
        savings: "貯蓄",
      },
      details: {
        yearlyData: "年間データ詳細",
      },
      analysis: {
        risk: "リスク分析",
        recommendations: "改善推奨事項",
      },
      table: {
        search: "検索...",
        age: "年齢",
        familyAge: "家族年齢",
        income: "収入",
        expense: "支出",
        savings: "貯蓄",
        assets: "資産残高",
        lifeEvents: "ライフイベント",
        ageValue: "{age}歳",
        spouse: "配偶者: {age}歳",
        children: "子ども",
        amount: "万円",
        noData: "データがありません",
      },
      timeline: {
        age: "年齢",
        event: "イベント",
        retirement: "退職",
        ageValue: "{age}歳",
        agePoint: "{age}歳時点",
        spouse: "配偶者: {age}歳",
        children: "子ども",
        neededAmount: "必要額: {amount}",
        assets: "資産: {amount}",
        education: "{childName}の{fundName}",
        child: "子ども",
        educationFund: "教育資金"
      },
      summary: {
        title: "サマリー",
        monthlyIncome: "月間収入",
        monthlyExpense: "月間支出",
        monthlyInvestment: "月間投資額",
        monthlySavings: "月間貯蓄額",
        totalAssets: "総資産",
        totalLiabilities: "総負債",
        netWorth: "純資産",
        finalAssets: "最終資産",
        peakAssets: "ピーク時の資産",
        retirementAssets: "退職時の資産",
        savingsRate: "貯蓄率",
        savingsRateDesc: "収入に対する貯蓄の割合",
        retirementBalance: "退職後の収支",
        balance: "収支",
        riskAssessment: "リスク評価",
        riskLow: "低リスク",
        riskMedium: "中リスク",
        riskHigh: "高リスク",
        negativeAssets: "将来、資産がマイナスになる期間があります。",
        positiveAssets: "資産は常にプラスを維持すると予想されます。",
        needImprovement: "収入・支出の改善が必要です。",
        unit: "万円",
        atAge: "{age}歳時点",
      },
      chart: {
        title: "資産推移プレビュー",
        noData: "データを入力してください",
        assets: "資産",
        income: "収入",
        expense: "支出",
      },
    },
    confirmation: {
      title: "確認"
    },
    validation: {
      error: "入力内容に誤りがあります。"
    },
  },
  login: "ログイン",
  register: "新規登録",
  loginDescription: "アカウントをお持ちでない方は新規登録してください。",
  registerDescription: "アカウントを作成して、ライフプランシミュレーションを始めましょう。",
  email: "メールアドレス",
  password: "パスワード",
  passwordRequirements: "パスワードは8文字以上で、英数字を含める必要があります。",
  loggingIn: "ログイン中...",
  registering: "登録中...",
  loginFailed: "ログインに失敗しました。",
  registrationSuccess: "登録が完了しました。",
  registrationFailed: "登録に失敗しました。",
  myPage: "マイページ",
  logout: "ログアウト",
  userProfile: "ユーザープロフィール",
  userProfileDescription: "プロフィール情報の管理",
  savedSimulations: "保存済みシミュレーション",
  savedSimulationsDescription: "過去に保存したシミュレーション結果の一覧",
  settings: "設定",
  accountSettings: "アカウント設定",
  accountSettingsDescription: "アカウント設定の管理",
  changePassword: "パスワード変更",
  changePasswordDescription: "パスワードを変更します",
} as Translation; 